module.exports = __webpack_public_path__ + "img/ocean-room-3.01612dba.jpg";